<template>
  <div>
    <el-row>
        <div class="breadcrumb-wrap">
            <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-custom">
            <el-breadcrumb-item>系统设置</el-breadcrumb-item>
            <el-breadcrumb-item>资源管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </el-row>

    <el-dialog :visible.sync="addVisible" @close="cleanForm('addResourceForm')" title="新增资源">
        <el-form :model="addResourceObj" status-icon :rules="rules" label-width="80px" ref="addResourceForm" class="ruleForm">
            <el-form-item label="资源名称" prop="resourceName">
                <el-input class="margin-space" placeholder="请输入资源名称" v-model="addResourceObj.resourceName">
                </el-input>
            </el-form-item>
            <el-form-item label="apiUrl" prop="apiUrl">
                <el-input class="margin-space" placeholder="请输入URL" v-model="addResourceObj.apiUrl">
                </el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
                <el-input class="margin-space" placeholder="请输入备注" v-model="addResourceObj.remarks">
                </el-input>
            </el-form-item>
            <MethodComponent @change="methodChange"/>
            <div style="text-align: right" class="margin-space">
                <div style="text-align: right" class="margin-space">
                    <el-button :loading="addLoading" type="primary" @click="addConfirmClick('addResourceForm')">
                    确认
                </el-button>
                </div>
            </div>
        </el-form>
    </el-dialog>
    <el-row>
      <el-col :span="6">
        <Menu ref="menu" @nodeClick="nodeClick"/>
      </el-col>
      <el-col :span="16">
        <LoadingNoDialog v-if="myResources.indexOf('/admin/resource/list') !== -1" :loading="loading">
          <div style="padding-bottom: 10px">资源列表</div>
          <el-button v-if="myResources.indexOf('/admin/resource/create') !== -1" @click='addClick' size="small" type="primary" style="margin-bottom: 8px">新增资源</el-button>

          <el-table
            class="clear-fix"
            border
            :data="tableData"
            style="width: 100%">
            <el-table-column
              align="center"
              type="index"
              width="50">
            </el-table-column>
            <el-table-column
              align="center"
              prop="resourceName"
              label="资源名称"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="apiUrl"
              label="apiUrl"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="method"
              label="请求方法"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="remarks"
              label="备注"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="sysCode"
              label="所属系统"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="createdAt"
              label="创建时间">
            </el-table-column>
            <el-table-column
              prop="s"
              label='操作'
              align="center"
              width="150">
              <template slot-scope="scope">
                <el-button
                  type="success"
                  size="mini"
                  plain
                  v-if="myResources.indexOf('/admin/resource/edit') !== -1"
                  @click="handleEdit(scope.$index, scope.row)">修改
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  plain
                  v-if="myResources.indexOf('/admin/resource/delete') !== -1"
                  @click="handleDelete(scope.$index, scope.row)">删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px;text-align: right">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10,20, 50, 100, 500,1000]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>

        </LoadingNoDialog>
      </el-col>
    </el-row>

  <ResourceEdit ref="editResource" @update="getList"></ResourceEdit>
  </div>
</template>

<script>
  import LoadingNoDialog from '../../components/LoadingNoDialog.vue'
  import axios from 'axios'
  import MethodComponent from './components/MethodComponent.vue'
  import ResourceTypeComponent from './components/ResouceTypeComponent.vue'
  import ResourceEdit from './components/ResourceEdit.vue'
  import Menu from './Menu.vue'

  const moment = require('moment')

  export default {
    name: 'Role',
    data() {
      let urlCheck = (rule, value, callback) => {
        let reg = /^\/(a-z0-9)*/
        // console.log(reg.test(value))
        if (!reg.test(value)) {
            callback(new Error("请输入以'/'开头的URL"));
        } else {
            callback();
        }
      };
      return {
        tableData: [],
        loading: true,
        addLoading: false,
        page: 1,
        size: 10,
        total: 0,
        addVisible: false,
        addResourceObj: {
          resourceName: '',
          remarks: '',
          apiUrl: '',
          method: 'GET',
          resourceType: 1,
          parentId: 0
        },
        rules:{
            resourceName:[
                {required:true,message:'资源名称不能为空',trigger:'blur'}
            ],
            apiUrl:[
                {required:true,message:'apiURL不能为空',trigger:'blur'},
                {validator:urlCheck,trigger:'blur'}
            ]
        },
        myResources:[]
      }
    },
    components: {
      LoadingNoDialog,
      MethodComponent,
      ResourceTypeComponent,
      Menu,
      ResourceEdit
    },
    mounted() {
      this.getList()
    },
    methods: {
      async getList() {
        this.loading = true
        let r = await axios.get('/admin/resource/list', {
          params: {
            page: this.page,
            size: this.size,
            parentId: this.addResourceObj.parentId
          }
        })
        // console.log(Object.assign({},r.data,{type:'资源列表'}))
        this.tableData = r.data.rows.map(item => Object.assign(item, {createdAt: moment(item.createdAt).format('YYYY/MM/DD HH:mm:ss')}))
        this.total = r.data.count
        this.getMyResources();
        this.loading = false
      },
      async getMyResources() {
        let r = await axios.get('/admin/my-resources');
        this.myResources = r.data.map(item => item.apiUrl);
      },
      cleanForm(formName){
        this.$refs[formName].resetFields();
      },
      handleSizeChange(val) {
        this.size = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      addConfirmClick(formName) {
        this.$refs[formName].validate(async valid => {
            if(valid){
                this.addLoading = true
                let res = await axios.get('/admin/menus/resources',{
                    params:{
                        parentId: this.addResourceObj.parentId,
                    }
                })
                if(res.data && res.data.length > 0){
                    this.$message.error('非法操作！')
                    this.addLoading = false
                    this.addVisible = false
                    return false;
                }
                let r = await axios.post('/admin/resource/create', this.addResourceObj)
                if(r.code == 0){
                    this.$message.success('新增成功')
                }
                this.addLoading = false
                this.addVisible = false
                this.getList()
                this.$refs.menu.getMenus();
            }
        })
      },
      nodeClick(row) {
        this.addResourceObj.parentId = row.id
        this.getList()
      },
      addClick() {
        this.addVisible = true
      },
      resourceTypeChange(val) {
        this.addResourceObj.resourceType = parseInt(val)
      },
      methodChange(val) {
        this.addResourceObj.method = val
        this.showMethodsError=false
      },
      handleEdit(index,row){
          this.$refs.editResource.setVisible(true,row);
      },
      async handleDelete(index, row) {
        this.$confirm(`此操作将删除 \'${row.resourceName}\', 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          beforeClose: async (action, instance, done)=>{
            if(action==='confirm'){
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = '删除中...'
              let r = await axios.delete('/admin/resource/delete', {params: {resourceId: row.id}})
              if(r.code==0){
                this.$message({
                  message:'删除成功',
                  type:'success'
                })
                instance.confirmButtonLoading = false
                done();
                this.getList()
              }else {
                this.$message({
                  message:'删除失败，请重试',
                  type:'error'
                })
                done();
              }
            }else{
              done()
            }
          }
        }).catch(err=>{})
      }
    }
  }
</script>
<style>
  .useryc-dialog-wrapper  .el-form-item__error{
    right: 0;
    left:auto
  }
  .useryc-width-dialog .el-dialog{
    width: 760px;
  }
</style>




// WEBPACK FOOTER //
// src/main/permission/Resource.vue